Pixlee.module('MosaicV2App', function(MosaicV2App, App, Backbone, Marionette, $) {
    var _this = this,
        API;

    MosaicV2App.on('start', function(options) {
        new MosaicV2App.Show.Controller(options);
    });
});